<template>
  <div class="card">
    <Toast />
    <div class="title">Daftar Outlet</div>

    <Toolbar class="p-mb-4">
      <template slot="left">
        <Button
          label="Tambah"
          icon="pi pi-plus"
          class="p-button-success"
          @click="openDialogCreate()"
        />
      </template>
      <template slot="right"> </template>
    </Toolbar>

    <DataTable
      :value="outlets"
      :lazy="false"
      :paginator="true"
      :rows="limit"
      :totalRecords="total_records"
      :loading="loading.filter"
      @page="getOutlets($event)"
      class="p-datatable-sm"
      :scrollable="true"
      scrollHeight="flex"
      :resizableColumns="true"
      columnResizeMode="expand"
    >
      <template #header></template>
      <template #empty>Data tidak ada</template>
      <template #loading>Loading ...</template>
      <Column field="code" header="Kode" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.code }}
        </template>
      </Column>
      <Column field="name" header="Nama Toko" :sortable="true">
        <template #body="slotProps">
          <span class="truncate-text" :title="slotProps.data.name">
            {{ slotProps.data.name }}
          </span>
        </template>
      </Column>
      <Column field="alias" header="Alias" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.alias }}
        </template>
      </Column>
      <Column field="type" header="Tipe" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.type }}
        </template>
      </Column>
      <Column field="address" header="Alamat" :sortable="true">
        <template #body="slotProps">
          <span class="truncate-text" :title="slotProps.data.address">
            {{ slotProps.data.address }}
          </span>
        </template>
      </Column>
      <Column field="phone" header="No HP" :sortable="true">
        <template #body="slotProps">
          <span class="truncate-text" :title="slotProps.data.phone">
            {{ slotProps.data.phone }}
          </span>
        </template>
      </Column>
      <Column field="status" header="Status" :sortable="true">
        <template #body="slotProps">
          <span
            v-if="slotProps.data.status === 1"
            class="p-text-bold"
            style="color: green"
            >Aktif</span
          >
          <span v-else class="p-text-bold" style="color: red">Tidak Aktif</span>
        </template>
      </Column>
      <Column>
        <template #body="slotProps">
          <Button
            icon="pi pi-pencil"
            class="p-button-rounded p-button-success p-button-sm"
            style="margin-right: 10px"
            @click="setEditOutlet(slotProps.data)"
          ></Button>
          <Button
            icon="pi pi-trash"
            class="p-button-rounded p-button-danger p-button-sm"
            @click="setDeleteOutlet(slotProps.data)"
            :disabled="loading.delete"
          ></Button>
        </template>
      </Column>
    </DataTable>

    <!-- dialog hapus outlet -->
    <Dialog
      :visible.sync="cancel_dialog"
      :style="{ width: '450px' }"
      header="Konfirmasi Pembatalan"
      :modal="true"
      class="p-fluid"
    >
      <div class="confirmation-content">
        Apakah kamu yakin ingin menghapus outlet <b>{{ cancel_data.name }}</b
        >?
      </div>

      <template #footer>
        <button
          type="button"
          label="No"
          icon="pi pi-times"
          class="btn btn-danger p-p-3"
          @click="cancel_dialog = false"
        >
          No
        </button>
        <button
          type="button"
          icon="pi pi-check"
          class="btn btn-primary p-p-3"
          @click="deleteOutlet()"
          :disabled="loading.delete"
        >
          Yes
          <span v-if="loading.delete">
            <i class="pi pi-spin pi-spinner" style="font-size: 12px"></i>
          </span>
        </button>
      </template>
    </Dialog>

    <!-- dialog tambah outlet -->
    <Dialog
      :visible.sync="create_dialog"
      :style="{ width: '500px' }"
      header="Tambah Outlet"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-field">
        <label for="">Kode</label>
        <InputText
          v-model="create_data.code"
          placeholder="Kode"
          @keyup.prevent="is_error.code = false"
        />
        <small class="p-error" v-if="is_error.code">{{ error_msg.code }}</small>
      </div>
      <div class="p-field">
        <label for="">Nama</label>
        <InputText
          v-model="create_data.name"
          placeholder="Nama"
          @keyup.prevent="is_error.name = false"
        />
        <small class="p-error" v-if="is_error.name">{{ error_msg.name }}</small>
      </div>
      <div class="p-field">
        <label for="">Alias</label>
        <InputText
          v-model="create_data.alias"
          placeholder="Alias"
          @keyup.prevent="is_error.alias = false"
        />
        <small class="p-error" v-if="is_error.alias">{{
          error_msg.alias
        }}</small>
      </div>
      <div class="p-field">
        <label for="">Type</label>
        <Dropdown
          v-model="type_selected"
          :options="jenis_outlet"
          placeholder="Pilih Type"
          @change="is_error.type = false"
        />
        <small class="p-error" v-if="is_error.type">{{ error_msg.type }}</small>
      </div>
      <div class="p-field">
        <label for="">Alamat</label>
        <InputText
          v-model="create_data.addres"
          placeholder="Alamat"
          @keyup.prevent="is_error.addres = false"
        />
        <small class="p-error" v-if="is_error.addres">{{
          error_msg.addres
        }}</small>
      </div>
      <div class="p-field">
        <label for="">Provinsi</label>
        <Dropdown
          v-model="province_selected"
          :options="provinces"
          optionLabel="name"
          placeholder="Pilih Provinsi"
          @input="getCities()"
          @change="is_error.province = false"
        />
        <small class="p-error" v-if="is_error.province">{{
          error_msg.province
        }}</small>
      </div>
      <div class="p-field">
        <label for="">Kota</label>
        <Dropdown
          v-model="city_selected"
          :options="cities"
          optionLabel="name"
          placeholder="Pilih Kota"
          @input="getDistricts()"
          :disabled="province_selected == null"
          @change="is_error.city = false"
        />
        <small class="p-error" v-if="is_error.city">{{ error_msg.city }}</small>
      </div>
      <div class="p-field">
        <label for="">Distrik</label>
        <Dropdown
          v-model="district_selected"
          :options="districts"
          optionLabel="name"
          @input="getZipCodes()"
          :disabled="province_selected == null || city_selected == null"
          placeholder="Pilih Distrik"
          @change="is_error.district = false"
        />
        <small class="p-error" v-if="is_error.district">{{
          error_msg.district
        }}</small>
      </div>
      <div class="p-field">
        <label for="">Kode Zip</label>
        <Dropdown
          v-model="zip_code_selected"
          :options="zip_codes"
          optionLabel="code"
          placeholder="Pilih Kode Zip"
          :disabled="
            province_selected == null ||
            city_selected == null ||
            district_selected == null
          "
          @change="is_error.zip_code = false"
        />
        <small class="p-error" v-if="is_error.zip_code">{{
          error_msg.zip_code
        }}</small>
      </div>
      <div class="p-field">
        <label for="">No Telepon</label>
        <InputText
          type="number"
          v-model="create_data.phone"
          placeholder="No Telepon"
          @keyup.prevent="is_error.phone = false"
        />
        <small class="p-error" v-if="is_error.phone">{{
          error_msg.phone
        }}</small>
      </div>

      <template #footer>
        <Button
          label="Cancel"
          class="p-button-outlined"
          @click="create_dialog = false"
        />
        <Button label="Save" class="btn btn-primary" @click="createOutlet()" />
      </template>
    </Dialog>

    <!-- update outlet -->
    <Dialog
      :visible.sync="update_dialog"
      :style="{ width: '500px' }"
      header="Edit Outlet"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-field">
        <label for="">Kode</label>
        <InputText
          v-model="create_data.code"
          placeholder="Kode"
          @keyup.prevent="is_error.code = false"
        />
        <small class="p-error" v-if="is_error.code">{{ error_msg.code }}</small>
      </div>
      <div class="p-field">
        <label for="">Nama</label>
        <InputText
          v-model="create_data.name"
          placeholder="Nama"
          @keyup.prevent="is_error.name = false"
        />
        <small class="p-error" v-if="is_error.name">{{ error_msg.name }}</small>
      </div>
      <div class="p-field">
        <label for="">Alias</label>
        <InputText
          v-model="create_data.alias"
          placeholder="Alias"
          @keyup.prevent="is_error.Alias = false"
        />
        <small class="p-error" v-if="is_error.alias">{{
          error_msg.alias
        }}</small>
      </div>
      <div class="p-field">
        <label for="">Type</label>
        <Dropdown
          v-model="type_selected"
          :options="edit_type_options"
          placeholder="Pilih Type"
          @change="is_error.type = false"
        />
        <small class="p-error" v-if="is_error.type">{{ error_msg.type }}</small>
      </div>
      <div class="p-field">
        <label for="">Alamat</label>
        <InputText
          v-model="create_data.addres"
          placeholder="Alamat"
          @keyup.prevent="is_error.addres = false"
        />
        <small class="p-error" v-if="is_error.addres">{{
          error_msg.addres
        }}</small>
      </div>
      <div class="p-field">
        <label for="">Provinsi</label>
        <Dropdown
          v-model="province_selected"
          :options="provinces"
          optionLabel="name"
          placeholder="Pilih Provinsi"
          @input="getCities()"
          @change="is_error.province = false"
        />
        <small class="p-error" v-if="is_error.province">{{
          error_msg.province
        }}</small>
      </div>
      <div class="p-field">
        <label for="">kota</label>
        <Dropdown
          v-model="city_selected"
          :options="cities"
          optionLabel="name"
          placeholder="Pilih Kota"
          @input="getDistricts()"
          :disabled="province_selected == null"
          @change="is_error.city = false"
        />
        <small class="p-error" v-if="is_error.city">{{ error_msg.city }}</small>
      </div>
      <div class="p-field">
        <label for="">Distrik</label>
        <Dropdown
          v-model="district_selected"
          :options="districts"
          optionLabel="name"
          @input="getZipCodes()"
          :disabled="province_selected == null || city_selected == null"
          placeholder="Pilih Distrik"
          @change="is_error.district = false"
        />
        <small class="p-error" v-if="is_error.district">{{
          error_msg.district
        }}</small>
      </div>
      <div class="p-field">
        <label for="">Kode Zip</label>
        <Dropdown
          v-model="zip_code_selected"
          :options="zip_codes"
          optionLabel="code"
          placeholder="Pilih Kode Zip"
          :disabled="
            province_selected == null ||
            city_selected == null ||
            district_selected == null
          "
          @change="is_error.zip_code = false"
        />
        <small class="p-error" v-if="is_error.zip_code">{{
          error_msg.zip_code
        }}</small>
      </div>
      <div class="p-field">
        <label for="">No Telepon</label>
        <InputText
          type="number"
          v-model="create_data.phone"
          placeholder="No Telepon"
          @keyup.prevent="is_error.phone = false"
        />
        <small class="p-error" v-if="is_error.phone">{{
          error_msg.phone
        }}</small>
      </div>

      <template #footer>
        <Button
          label="Cancel"
          class="p-button-outlined"
          @click="update_dialog = false"
        />
        <Button label="Save" class="btn btn-primary" @click="updateOutlet()" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user', 'isAuthenticated']),

    // Options for the Edit dialog only. An outlet may sit on a type that has
    // since been dropped from outlet_types; that type has to stay selectable or
    // the dropdown renders blank and saving silently resets the outlet — the
    // bug this page is being fixed for. Derived rather than appended to
    // jenis_outlet, so a decommissioned type never leaks into the Create
    // dialog, where the backend would reject it with a generic failure.
    // Recomputing also means a late getOutletTypes() response cannot drop the
    // current type while the dialog is open.
    edit_type_options() {
      if (
        this.type_selected &&
        !this.jenis_outlet.includes(this.type_selected)
      ) {
        return [...this.jenis_outlet, this.type_selected]
      }
      return this.jenis_outlet
    }
  },
  watch: {
    user() {
      this.getAuthUser()
    }
  },
  data() {
    return {
      cancel_dialog: false,
      create_dialog: false,
      update_dialog: false,

      loading: {
        filter: false,
        create: false,
        delete: false
      },

      outlets: [],
      district_selected: null,
      city_selected: null,
      province_selected: null, //provinsi
      zip_code_selected: null,

      jenis_outlet: [],

      type_selected: null,
      districts: null,
      cities: null,
      provinces: null, //list provinsi
      zip_codes: null,
      outlet_id_update: null,

      create_data: {
        code: '',
        name: '',
        alias: '',
        type: null,
        status: null,
        addres: '',
        district: null,
        city: null,
        province: null,
        zip_code: null,
        phone: ''
      },
      cancel_data: {},

      is_error: {
        code: '',
        name: '',
        alias: '',
        type: null,
        status: 0,
        addres: '',
        district: null,
        city: null,
        province: null,
        zip_code: null,
        phone: ''
      },
      error_msg: {
        code: '',
        name: '',
        alias: '',
        type: null,
        status: 0,
        addres: '',
        district: null,
        city: null,
        province: null,
        zip_code: null,
        phone: ''
      },

      limit: 5,
      total_records: 0
    }
  },
  mounted() {
    this.getAuthUser()
    this.getOutlets()
    this.getOutletTypes()
    this.getProvinces()
  },
  methods: {
    getAuthUser() {
      console.info(this.user)
    },

    // get all outlets
    async getOutlets() {
      this.loading.filter = true
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/outlets`
        )
        if (response.status === 200) {
          this.outlets = response.data.data.outlets
        }
      } catch (error) {
        console.error('Error fetching outlets:', error)
      } finally {
        this.loading.filter = false
      }
    },

    // get one outlet
    async getOutlet(data) {
      this.loading.filter = true
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/outlets/${data.id}`
        )
        if (response.status === 200) {
          this.outlet_id_update = response.data.data.outlets.id
        }
      } catch (error) {
        console.error('Error fetching outlet:', error)
      } finally {
        this.loading.filter = false
      }
    },

    // get all provinces
    async getDistricts() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/districts?city_id=${this.city_selected.id}`
        )
        if (response.status === 200) {
          this.districts = response.data.data.district
        }
      } catch (error) {
        console.error('Error fetching districts:', error)
      } finally {
        this.loading.filter = false
      }
    },

    async getCities() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/cities?province_id=${this.province_selected.id}`
        )
        if (response.status === 200) {
          this.cities = response.data.data.Cities
        }
      } catch (error) {
        console.error('Error fetching cities:', error)
      } finally {
        this.loading.filter = false
      }
    },

    async getProvinces() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/provinces`
        )
        if (response.status === 200) {
          this.provinces = response.data.data.provinces
        }
      } catch (error) {
        console.error('Error fetching provinces:', error)
      } finally {
        this.loading.filter = false
      }
    },

    async getZipCodes() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/urbans?district_id=${this.district_selected.id}`
        )
        if (response.status === 200) {
          this.zip_codes = response.data.data.urbans.map(zip_code => {
            return {
              code: `${zip_code.name} - ${zip_code.zip_code}`,
              zip_code: zip_code.zip_code
            }
          })
        }
      } catch (error) {
        console.error('Error fetching zip codes:', error)
      } finally {
        this.loading.filter = false
      }
    },

    // type list comes from the API's outlet_types config, not a hardcoded list
    async getOutletTypes() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/outlets/types`
        )
        const types = response.data.data.types
        this.jenis_outlet = Array.isArray(types) ? types : []
      } catch (error) {
        console.error('Error fetching outlet types:', error)
        // Type is required to save, so a silent failure here leaves the
        // operator stuck on "Isi Type" with no idea why the list is empty.
        this.showToast('error', 'Gagal memuat pilihan type outlet')
      }
    },

    openDialogCreate() {
      this.resetCreateData()
      this.create_dialog = true
    },

    resetCreateData() {
      this.create_data = {
        code: '',
        name: '',
        alias: '',
        type: null,
        status: null,
        addres: '',
        district: null,
        city: null,
        province: null,
        zip_code: null,
        phone: ''
      }
      this.is_error = {
        code: false,
        name: false,
        alias: false,
        type: false,
        addres: false,
        district: false,
        city: false,
        province: false,
        zip_code: false,
        phone: false
      }
      this.error_msg = {
        code: '',
        name: '',
        alias: '',
        type: '',
        addres: '',
        district: '',
        city: '',
        province: '',
        zip_code: '',
        phone: ''
      }
      this.city_selected = null
      this.district_selected = null
      this.province_selected = null
      this.zip_code_selected = null
      this.type_selected = null
    },

    async setEditOutlet(item) {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/outlets/${item.id}`
        )

        if (response.status === 200) {
          let data = response.data.data.outlets
          this.outlet_id_update = data.id

          this.create_data.code = data.code
          this.create_data.name = data.name

          // edit_type_options keeps this selectable even if the type is no
          // longer in outlet_types, without touching the shared list
          this.type_selected = data.type
          this.create_data.addres = data.address
          this.create_data.phone = data.phone
          this.create_data.alias = data.alias

          // get data province
          this.province_selected = this.provinces.find(
            province => province.name === data.province
          )
          this.create_data.province = this.province_selected.id
          await this.getCities(false)

          // get data city
          this.city_selected = this.cities.find(city => city.name === data.city)
          this.create_data.city = this.city_selected.id
          await this.getDistricts(false)

          // get data district
          this.district_selected = this.districts.find(
            district => district.name === data.district
          )
          this.create_data.district = this.district_selected.id
          await this.getZipCodes(false)

          // get data zip_code
          this.zip_code_selected = this.zip_codes.find(
            zip_code => zip_code.zip_code === data.zip_code
          )
          this.create_data.zip_code = parseInt(this.zip_code_selected.zip_code)
        }
      } catch (error) {
        console.error('Error set data outlet:', error)
      } finally {
        this.update_dialog = true
      }
    },

    setDeleteOutlet(data) {
      this.cancel_data = data
      this.cancel_dialog = true
    },

    async createOutlet() {
      try {
        this.loading.create = true
        this.resetErrors()
        // Error checking
        this.checkErrors()
        if (this.hasErrors()) return
        // Set status to 1 (active)
        this.create_data.status = 1

        // Post request to create outlet
        const response = await this.$http.post(
          `${process.env.VUE_APP_API_URL}/outlet`,
          this.create_data
        )

        if (response.status === 200) {
          this.create_dialog = false
          this.getOutlets()
          this.resetCreateData()
          this.showToast('success', 'Berhasil menambahkan outlet')
        } else {
          this.showToast('error', 'Gagal menambahkan outlet')
        }
      } catch (error) {
        this.showToast('error', 'Gagal menambahkan outlet')
      } finally {
        this.loading.create = false
      }
    },

    async updateOutlet() {
      try {
        this.loading.create = true
        this.resetErrors()

        // Error checking
        this.checkErrors()

        if (this.hasErrors()) return

        // Set status to 1 (active)
        this.create_data.status = 1

        // Put request to update outlet
        const response = await this.$http.put(
          `${process.env.VUE_APP_API_URL}/outlet/${this.outlet_id_update}`,
          this.create_data
        )

        if (response.status === 200) {
          this.getOutlets()
          this.showToast('success', 'Berhasil update outlet')
          this.resetCreateData()
          this.update_dialog = false
        } else {
          this.showToast('error', 'Gagal update outlet')
        }
      } catch (error) {
        this.showToast('error', 'Gagal update outlet')
      } finally {
        this.loading.create = false
      }
    },

    // Utility methods
    resetErrors() {
      this.is_error = {}
      this.error_msg = {}
    },

    checkErrors() {
      // Error check code
      if (!this.create_data.code) {
        this.is_error.code = true
        this.error_msg.code = 'Isi Code'
      } else {
        this.create_data.code = this.create_data.code.toUpperCase()
      }

      // Error check name
      if (!this.create_data.name) {
        this.is_error.name = true
        this.error_msg.name = 'Isi nama'
      } else {
        this.create_data.name = this.create_data.name.toUpperCase()
      }

      // Error check alias (only for createOutlet)
      if (this.create_data.alias !== undefined) {
        if (!this.create_data.alias) {
          this.is_error.alias = true
          this.error_msg.alias = 'Isi nama'
        } else {
          this.create_data.alias = this.create_data.alias.toUpperCase()
        }
      }

      // Error check type
      if (this.type_selected) {
        this.create_data.type = this.type_selected
      } else {
        this.is_error.type = true
        this.error_msg.type = 'Isi Type'
      }

      // Error check addres
      if (!this.create_data.addres) {
        this.is_error.addres = true
        this.error_msg.addres = 'Isi Address'
      } else {
        this.create_data.addres = this.create_data.addres.toUpperCase()
      }

      // Error check district
      if (this.district_selected) {
        this.create_data.district = this.district_selected.id
      } else {
        this.is_error.district = true
        this.error_msg.district = 'Isi District'
      }

      // Error check city
      if (this.city_selected) {
        this.create_data.city = this.city_selected.id
      } else {
        this.is_error.city = true
        this.error_msg.city = 'Isi City'
      }

      // Error check province
      if (this.province_selected) {
        this.create_data.province = this.province_selected.id
      } else {
        this.is_error.province = true
        this.error_msg.province = 'Isi Province'
      }

      // Error check zip_code
      if (this.zip_code_selected) {
        this.create_data.zip_code = parseInt(this.zip_code_selected.zip_code)
      } else {
        this.is_error.zip_code = true
        this.error_msg.zip_code = 'Isi Zip Code'
      }

      // Error check phone
      if (!this.create_data.phone) {
        this.is_error.phone = true
        this.error_msg.phone = 'Isi Phone'
      }
    },

    hasErrors() {
      return Object.values(this.is_error).some(error => error)
    },

    async deleteOutlet() {
      try {
        this.loading.delete = true

        const response = await this.$http.delete(
          `${process.env.VUE_APP_API_URL}/outlet?id=${this.cancel_data.id}`
        )

        if (response.status === 200) {
          this.getOutlets()
          this.showToast('success', 'Berhasil menghapus outlet')
        } else {
          this.showToast('error', 'Gagal menghapus outlet')
        }
      } catch (error) {
        this.showToast('error', 'Gagal menghapus outlet')
      } finally {
        this.loading.delete = false
        this.cancel_dialog = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}

.truncate-text {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
</style>
